import * as R from 'ramda';
import { ActionType } from '../../../core/redux/actionType';
import { AppState, makeInitialState } from '../../../core/redux/appState';
import { Action } from 'redux';


type LogOutAction = {
  type: ActionType.LogOut;
  isMobile: boolean;
}


export const logOutAction = (isMobile: boolean): LogOutAction => ({
  type:     ActionType.LogOut,
  isMobile: isMobile,
});

export const logOutReducer = (state: AppState, incomingAction: Action): AppState => {
  if (incomingAction.type !== ActionType.LogOut) {
    return state;
  }

  const action = incomingAction as LogOutAction;

  return R.mergeRight(
    makeInitialState(state.locale.lang, action.isMobile),
    {
      sessionStorageLoaded: true,
      featureFlags:         state.featureFlags,
      config:               state.config,
      locale:               state.locale,
      allLanguages:         state.allLanguages,
    },
  );
};
